import React from 'react'

import { Text } from '~/components/text/Text'
import { styled } from '~/styled'

import { useSidebarState } from '../side-bar/SideBarContext'

const StyledNavigationMenuVerticalText = styled(Text, {
  base: [
    'font-(--navigation-menu-vertical-item-font-weight)',
    'w-max',
    'max-w-40',
    'text-left',
    'motion-safe:duration-125',
    'motion-safe:ease-out',
    'motion-safe:transition-[opacity,translate]'
  ],
  variants: {
    isExpanded: {
      true: ['opacity-100', 'motion-safe:translate-0'],
      false: ['opacity-0', 'motion-safe:translate-x-2']
    }
  }
})

type TStyledNavigationMenuVerticalTextProps = React.ComponentProps<
  typeof StyledNavigationMenuVerticalText
>

export const NavigationMenuVerticalText = (
  props: TStyledNavigationMenuVerticalTextProps
): React.JSX.Element => {
  const { isExpanded } = useSidebarState()

  return (
    <StyledNavigationMenuVerticalText
      size="md"
      as="span"
      {...props}
      isExpanded={isExpanded}
    />
  )
}
